import React from 'react';

import { faChevronRight, faHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { css, styled } from 'styled-components';

import GenericContainer from 'components/GenericContainer';
import IconLink from 'components/IconLink/IconLink';
import BreadcrumbItem from 'components/Layout/Header/components/Breadcrumbs/BreadcrumbItem';

import { BreadcrumbI } from 'interfaces/content-stack/contentStack.types';

import { buildBreadcrumbUrls } from 'utils/functions';

const BreadcrumbsWrapper = styled.div<{ $scrollUp: boolean }>(
  ({ theme, $scrollUp }) => css`
    background-color: ${theme.colors.whiteSmoke};
    border-bottom: 0.0625rem solid ${theme.colors.secondaryGray2};
    color: ${theme.colors.primaryRed};
    position: sticky;
    display: flex;
    font-size: 0.75rem;
    align-items: center;
    justify-content: center;
    height: 2.5rem;
    visibility: ${$scrollUp ? 'hidden' : 'visible'};
    transform: ${$scrollUp ? 'translateY(-200%)' : 'none'};
    transition: all 0.5s;
    top: 6.25rem;
    width: 100%;
    z-index: 10;

    @media (max-width: ${theme.breakpoints.lg}) {
      top: 3.8125rem;
      padding: 0 1rem;
      display: none;
    }
  `
);

const Breadcrumbs = ({
  breadcrumbs,
  page,
  scrollDirection,
}: {
  breadcrumbs: BreadcrumbI[];
  page: BreadcrumbI;
  scrollDirection?: string;
}) => {
  if (!breadcrumbs || breadcrumbs.length < 1) return null;

  return (
    <BreadcrumbsWrapper $scrollUp={scrollDirection === 'up'}>
      <GenericContainer $styles={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <IconLink to='/'>
          <FontAwesomeIcon icon={faHouse} />
        </IconLink>
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={crumb.title}>
            <FontAwesomeIcon icon={faChevronRight} />
            <BreadcrumbItem
              to={buildBreadcrumbUrls(breadcrumbs.slice(0, index), crumb.url)}
              activeStyle={{ fontWeight: '600', opacity: '1' }}
            >
              {crumb.title}
            </BreadcrumbItem>
          </React.Fragment>
        ))}
        <>
          <FontAwesomeIcon icon={faChevronRight} />
          <BreadcrumbItem
            to={buildBreadcrumbUrls(breadcrumbs, page.url)}
            activeStyle={{ fontWeight: '600', opacity: '1' }}
          >
            {page.title}
          </BreadcrumbItem>
        </>
      </GenericContainer>
    </BreadcrumbsWrapper>
  );
};

export default Breadcrumbs;
